/*
Documentation

*** make sure to declare all action types in actions.js one folder level back

*/

import * as actionTypes from '../../actions';

const initialState = {
    email_templates: [
       { _id: 123, name: 'email_tempalate test 1' },
       { _id: 456, name: 'email_tempalate test 2' },
    ],
}

const reducer = (state = initialState, action) => {

    switch (action.type) {

        case actionTypes.SET_EMAIL_TEMPLATES:

            return {
                ...state,
                email_templates: action.payload,
            }

        default: return state;

    }

}

export default reducer;
